import { Stack } from "@fluentui/react";
import React from "react";
import { ShimmerLine } from "../../../Shimmer/ShimmerLine/ShimmerLine";
import { FeatureHeight } from "../../Feature.types";
import { getImageHeight } from "../FeatureImage";

export interface FeatureImageShimmerProps {
    /**
     * Height of the feature component. Default is medium.
     */
    readonly height?: FeatureHeight;
}

export const FeatureImageShimmer: React.FC<FeatureImageShimmerProps> = ({
    height = "medium"
}) => {

    return (
        <Stack>
            <ShimmerLine height={getImageHeight(height)} />
        </Stack>
    );
};
